import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['status']
  static values = {
    url: String,
    enabled: { type: Boolean, default: false },
    intervalMs: { type: Number, default: 8000 }
  }

  connect () {
    if (!this.enabledValue || !this.urlValue) return
    if (!navigator.geolocation) {
      this.setStatus('GPS not available on this device.')
      return
    }

    // Send one fix immediately so the buyer map updates as soon as the rider accepts.
    navigator.geolocation.getCurrentPosition(
      (pos) => this.postLocation(pos),
      () => {},
      { enableHighAccuracy: true, maximumAge: 0, timeout: 12000 }
    )

    this.watchId = navigator.geolocation.watchPosition(
      (pos) => this.postLocation(pos),
      () => this.setStatus('Unable to read GPS. Check location permission.'),
      { enableHighAccuracy: true, maximumAge: 5000, timeout: 15000 }
    )
  }

  disconnect () {
    if (this.watchId != null) {
      navigator.geolocation.clearWatch(this.watchId)
      this.watchId = null
    }
  }

  async postLocation (position) {
    const { latitude, longitude, accuracy } = position.coords
    const token = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      const response = await fetch(this.urlValue, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token || ''
        },
        body: JSON.stringify({
          latitude,
          longitude,
          accuracy_meters: accuracy
        })
      })

      if (response.ok) {
        this.setStatus('Live location sharing…')
      }
    } catch (_error) {
      this.setStatus('Location sync paused. Retrying…')
    }
  }

  setStatus (text) {
    if (this.hasStatusTarget) this.statusTarget.textContent = text
  }
}
